import { render, staticRenderFns } from "./novo-usuario.vue?vue&type=template&id=03dcf886&scoped=true&"
import script from "./novo-usuario.vue?vue&type=script&lang=js&"
export * from "./novo-usuario.vue?vue&type=script&lang=js&"
import style0 from "./novo-usuario.vue?vue&type=style&index=0&id=03dcf886&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03dcf886",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VSelect,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03dcf886')) {
      api.createRecord('03dcf886', component.options)
    } else {
      api.reload('03dcf886', component.options)
    }
    module.hot.accept("./novo-usuario.vue?vue&type=template&id=03dcf886&scoped=true&", function () {
      api.rerender('03dcf886', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Modal/novoUsuario/novo-usuario.vue"
export default component.exports